import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import HeaderItem from './HeaderItem'

/**
 * @see Extends [HeaderItem](/#/Components/Header?id=headeritem)
 */
const HeaderLogo = ({ children, className, ...rest }) => (
  <HeaderItem
    {...rest}
    className={classnames('ln-c-header__item--logo', className)}
  >
    {children}
  </HeaderItem>
)

HeaderLogo.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}

HeaderLogo.defaultProps = {
  children: undefined,
  className: undefined,
}

HeaderLogo.displayName = 'HeaderLogo'

export default HeaderLogo
